import { apiRequest } from './client'
import type {
  SilkCreatorContestAwardList,
  SilkCreatorProfile,
  SilkCreatorPublicCopyrightList,
  SilkMarketplaceListingList,
  SilkWorkList,
} from './types'

export type CreatorWorksOrderBy = 'published_at' | 'view_count' | 'like_count' | 'created_at'

export const creatorsApi = {
  /** 公开:创作者主页(可选 JWT 返回 is_following) */
  profile: (id: number | string) =>
    apiRequest<SilkCreatorProfile>(`/api/v1/creators/${encodeURIComponent(String(id))}`),

  /** 公开:按 username 查创作者主页(可选 JWT) */
  profileByUsername: (username: string) =>
    apiRequest<SilkCreatorProfile>(
      `/api/v1/creators/by-username/${encodeURIComponent(username)}`,
    ),

  /** 关注创作者 */
  follow: (id: number | string) =>
    apiRequest<{ ok: boolean }>(`/api/v1/creators/${encodeURIComponent(String(id))}/follow`, {
      method: 'POST',
    }),

  /** 取消关注 */
  unfollow: (id: number | string) =>
    apiRequest<{ ok: boolean }>(`/api/v1/creators/${encodeURIComponent(String(id))}/follow`, {
      method: 'DELETE',
    }),

  /** 公开:创作者已发布作品列表 */
  works: (
    id: number | string,
    params?: { limit?: number; offset?: number; order_by?: CreatorWorksOrderBy },
  ) =>
    apiRequest<SilkWorkList>(`/api/v1/creators/${encodeURIComponent(String(id))}/works`, {
      query: params,
      auth: false,
    }),

  contests: (id: number | string, params?: { limit?: number; offset?: number }) =>
    apiRequest<SilkCreatorContestAwardList>(
      `/api/v1/creators/${encodeURIComponent(String(id))}/contests`,
      { query: params, auth: false },
    ),

  copyrights: (id: number | string, params?: { limit?: number; offset?: number }) =>
    apiRequest<SilkCreatorPublicCopyrightList>(
      `/api/v1/creators/${encodeURIComponent(String(id))}/copyrights`,
      { query: params, auth: false },
    ),

  listings: (id: number | string, params?: { limit?: number; offset?: number }) =>
    apiRequest<SilkMarketplaceListingList>(
      `/api/v1/creators/${encodeURIComponent(String(id))}/listings`,
      { query: params, auth: false },
    ),
}

export {
  creatorPublicPath,
  creatorPathFromWork,
  creatorLabelFromWork,
} from '@/utils/userDisplay'
